import type { AxiosInstance } from 'axios';
import { PERSONNEL_API_ENDPOINTS } from './endpoints';
import type { ProfilesListSuccessResponse } from './types/ProfileApiResponse';

/**
 * Creates an HTTP client for Profiles API
 *
 * Thin wrapper over Axios to call the profiles endpoint.
 *
 * @param props Configuration with HTTP client instance
 * @returns Object with HTTP methods for profiles
 *
 * @example
 * const client = createProfileHttpClient({ httpClient: connectApi });
 * const res = await client.getProfiles();
 */
export const createProfileHttpClient = (props: { httpClient: AxiosInstance }) => {
  const { httpClient } = props;

  /**
   * Retrieves profiles from API without query parameters
   *
   * @returns Profiles list success response
   */
  const getProfiles = async (): Promise<ProfilesListSuccessResponse> => {
    const response = await httpClient.get<ProfilesListSuccessResponse>(PERSONNEL_API_ENDPOINTS.PROFILES.GET);
    return response.data;
  };

  return {
    getProfiles,
  };
};
